<template>
    <div class="br-s f fh fa-c u-us-n ath-warning">
        <AthVisualIcon :name="icon" uiSize="m" class="sp-l-s sp-r-s" />
        <div class="ath-warning-text-area f fv ta-l sp-s fg br-s ws-pl ">
            <span v-if="title" class="ath-warning-title">{{ title }}</span>
            <span v-if="lbl" class="ath-warning-lbl" v-html="$options.filters.athT(lbl, params || {})"></span>
        </div>
    </div>
</template>

<script>
import AthVisualIcon from '../../components/atoms/visuals/Icon.vue';

export default {
    name: 'mead-warning',
    props: {
        /**
         * Translation key for the warning's main message text, run through the
         * `athT` filter and rendered as HTML.
         */
        lbl     : {type: [Boolean, String], default: () => false},
        /**
         * Bold title text shown above the message, rendered as plain text
         * (not translated).
         */
        title   : {type: [Boolean, String], default: () => false},
        /**
         * Name of the icon shown alongside the warning text, passed to `AthVisualIcon`.
         */
        icon    : {type: [Boolean, String], default: () => false},
        /**
         * Interpolation params passed to the `athT` filter alongside `lbl`.
         */
        params  : {type: Object, default: () => ({})},
    },
    components: {
        AthVisualIcon,
    },
};
</script>

<style lang="scss" scoped>
@use '../../../sass/variables' as *;

.ath-warning {
    border: 2px solid var(--c-brand-warning-bg);
    background-color: var(--c-brand-warning-bg);
    color: var(--c-brand-warning-fg);
    line-height: $lh-xs;
    font-family: $ff-be;
    min-height: 4rem;

    &.el--t-danger {
        background-color: var(--c-brand-danger-bg);
        border-color: var(--c-brand-danger-bg);
        color: var(--c-brand-danger-fg);
    }

    .ath-warning-text-area {
        background-color: var(--c-panel-bg);
    }

    .ath-warning-lbl {
        font-size: $fs-s;
        word-break: break-word;
    }

    .ath-warning-title {
        font-weight: bold;
        font-size: $fs-s;
        background-color: var(--c-panel-bg);
        word-break: break-word;
    }

    .ath-warning-lbl {
        &,
        & > * {
            color: var(--c-txt);
        }

        a {
            font-weight: bold;
            text-decoration: underline;
        }
    }
}

</style>
